import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StarRatingComponent from 'react-star-rating-component';
import NumberFormat from 'react-number-format';
import './MarginStars.css';

import fetchClient from '../../components/common/FetchClient';

import 'font-awesome/css/font-awesome.min.css';

export class MarginStars extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rate1margin: 0,
            rate2margin: 0,
            rate3margin: 0,
            currentMargin: 0,
            currentlyAssignedRate: 1
        };
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
    }

    componentWillReceiveProps(nextProps) {
        var that = this;
        console.log('margin stars begin');

        // This method runs when incoming props (e.g., route params) change

        if (nextProps.cost
            && nextProps.price
            && nextProps.itemId
            && nextProps.price !== this.props.price) {

            const url = `/api/PriceRate/GetPriceRateData`;

            fetchClient(url, {
                params: {
                    azureToken: '',
                    customer: localStorage.getItem('customer'),
                    itemId: nextProps.itemId,
                    cost: nextProps.cost,
                    price: nextProps.price
                }
            })
            .then(function (resp) {
                console.log('MarginStars', resp);
                if (resp) {

                    var rateResp = resp.data.PriceRateItemResp.PriceRate;
                    that.setState({ rate1margin: Number(rateResp[0].Margin) });
                    that.setState({ rate2margin: Number(rateResp[1].Margin) });
                    that.setState({ rate3margin: Number(rateResp[2].Margin) });

                    that.setState({ currentMargin: (nextProps.price - nextProps.cost) / nextProps.price * 100 })
                    
                    var assignedRate = 0;
                    if (rateResp[0].CurrentlyAssigned === "1") { assignedRate = 1; }
                    if (rateResp[1].CurrentlyAssigned === "1") { assignedRate = 2; }
                    if (rateResp[2].CurrentlyAssigned === "1") { assignedRate = 3; }

                    that.setState({ currentlyAssignedRate: assignedRate });
                    console.log('rateresp', rateResp);
                }
            });
        }
    }

    render() {
        return (
            <div className="margin-stars-layout">
                <StarRatingComponent
                    name="ratePM"
                    value={this.props.cost ?
                        this.state.currentMargin >= this.state.rate3margin ?
                            3
                            :
                            this.state.currentMargin >= this.state.rate2margin ?
                            2
                            :
                            this.state.currentMargin >= this.state.rate1margin ?
                            1
                            :
                            0
                        :
                        0
                    }
                    starCount={3}
                    starColor="#ffb400"
                    emptyStarColor="#ffb400"
                    editing={false}
                    renderStarIcon={(index, value) => {
                        return (
                            <span>
                                <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />
                            </span>
                        );
                    }}
                    renderStarIconHalf={() => {
                        return (
                            <span>
                                <span style={{ position: 'absolute' }}><i className="fa fa-star-half-o" /></span>
                                <span><i className="fa fa-star-half-o" /></span>
                            </span>
                        );
                    }}
                />

                <span className="margin-stars-amount">Amount $</span>

                <span className={this.props.showDetails ?
                    'margin-stars-gp show-details'
                    :
                    'margin-stars-gp hide-details'}>GP%</span>
                <br />

                <div className={this.props.showDetails ?
                    'margin-stars-offset show-details'
                    :
                    'margin-stars-offset hide-details'}
                >

                    <StarRatingComponent
                        name="ratePM"
                        editing={false}
                        value={1}
                        starCount={3}
                        starColor="#ffb400"
                        emptyStarColor="#ffb400"
                        renderStarIcon={(index, value) => {
                            return (
                                <span>
                                    <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />
                                </span>
                            );
                        }}
                    />

                    <NumberFormat value={this.props.cost / (1 - this.state.rate1margin / 100)}
                        thousandSeparator={true}
                        displayType={'text'} prefix={''}
                        className={this.state.currentlyAssignedRate === 1 ?
                            'margin-stars-currently-assigned margin-stars-amount inline'
                            : 'margin-stars-currently-unassigned margin-stars-amount inline'}
                        fixedDecimalScale={true} decimalScale={2} />

                    <NumberFormat value={this.state.rate1margin} thousandSeparator={true}
                        displayType={'text'} prefix={' '}
                        className={this.state.currentlyAssignedRate === 1 ?
                            'margin-stars-currently-assigned margin-stars-gp inline'
                            : 'margin-stars-currently-unassigned margin-stars-gp inline'}
                        fixedDecimalScale={true} decimalScale={1} />
                    <br />

                    <StarRatingComponent
                        name="ratePM"
                        editing={false}
                        value={2}
                        starCount={3}
                        starColor="#ffb400"
                        emptyStarColor="#ffb400"
                        renderStarIcon={(index, value) => {
                            return (
                                <span>
                                    <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />
                                </span>
                            );
                        }}
                    />

                    <NumberFormat value={this.props.cost / (1 - this.state.rate2margin / 100)}
                        thousandSeparator={true}
                        displayType={'text'} prefix={''}
                        className={this.state.currentlyAssignedRate === 2 ?
                            'margin-stars-currently-assigned margin-stars-amount inline'
                            : 'margin-stars-currently-unassigned margin-stars-amount inline'}
                        fixedDecimalScale={true} decimalScale={2} />

                    <NumberFormat value={this.state.rate2margin} thousandSeparator={true}
                        displayType={'text'} prefix={' '} 
                        className={this.state.currentlyAssignedRate === 2 ?
                            'margin-stars-currently-assigned margin-stars-gp inline'
                            : 'margin-stars-currently-unassigned margin-stars-gp inline'}
                        fixedDecimalScale={true} decimalScale={1} />
                    <br />

                    <StarRatingComponent
                        name="ratePM"
                        editing={false}
                        value={3}
                        starCount={3}
                        starColor="#ffb400"
                        emptyStarColor="#ffb400"
                        renderStarIcon={(index, value) => {
                            return (
                                <span>
                                    <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />
                                </span>
                            );
                        }}
                    />

                    <NumberFormat value={this.props.cost / (1 - this.state.rate3margin / 100)}
                        thousandSeparator={true}
                        displayType={'text'} prefix={''}
                        className={this.state.currentlyAssignedRate === 3 ?
                            'margin-stars-currently-assigned margin-stars-amount inline'
                            : 'margin-stars-currently-unassigned margin-stars-amount inline'}
                        fixedDecimalScale={true} decimalScale={2} />

                    <NumberFormat value={this.state.rate3margin} thousandSeparator={true}
                        displayType={'text'} prefix={' '}
                        className={this.state.currentlyAssignedRate === 3 ?
                            'margin-stars-currently-assigned margin-stars-gp inline'
                            : 'margin-stars-currently-unassigned margin-stars-gp inline'}
                        fixedDecimalScale={true} decimalScale={1} />

                </div>
            </div>
        );
    }
}

MarginStars.propTypes = {
    account: PropTypes.string,
    cost: PropTypes.number,
    price: PropTypes.number,
    showDetails: PropTypes.bool,
    itemId: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/sales/MarginStars.js